import {useEffect, useRef, useState} from 'react'
import {Banner} from '@primer/react'
import {propertyDefinitionSettingsPath} from '@github-ui/paths'

interface Props {
  sourceName: string
  propertyName: string
  repositoryCount: number
}

export function SuccessBanner({sourceName, propertyName, repositoryCount}: Props) {
  const [isDismissed, setIsDismissed] = useState(false)
  const bannerRef = useRef<HTMLElement>(null)

  useEffect(() => {
    bannerRef.current?.focus()
  }, [])

  if (isDismissed) return null

  const path = propertyDefinitionSettingsPath({pathPrefix: 'organizations', sourceName, tab: 'set-values'})

  return (
    <Banner
      ref={bannerRef}
      onDismiss={() => setIsDismissed(true)}
      title={`Ruleset updated to target ${propertyName} value`}
      description={`The ${propertyName} property has been created and applied to the ${repositoryCount} selected repositories. You should make sure to set values for the remaining repositories.`}
      variant="success"
      primaryAction={
        <Banner.PrimaryAction as="a" rel="noopener noreferrer" target="_blank" href={path}>
          Set values for remaining repositories
        </Banner.PrimaryAction>
      }
    />
  )
}
